// Shared Google Maps JS API loader. Loads the script once (with the Places
// library, so address autocomplete can reuse it) and resolves to window.google.
// Requires REACT_APP_GOOGLE_MAPS_API_KEY in the frontend env.
let _promise = null;

export function loadGoogleMaps() {
  if (window.google?.maps) return Promise.resolve(window.google);
  if (_promise) return _promise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return Promise.reject(new Error("Missing REACT_APP_GOOGLE_MAPS_API_KEY"));

  _promise = new Promise((resolve, reject) => {
    // Reuse a script tag that another component may have already injected.
    const existing = document.querySelector("script[data-gmaps]");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      existing.addEventListener("error", () => reject(new Error("Failed to load Google Maps")));
      if (window.google?.maps) resolve(window.google);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.setAttribute("data-gmaps", "1");
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error("Failed to load Google Maps script"));
    document.head.appendChild(script);
  });
  return _promise;
}

// Dark "night mode" styling so the map matches the app's dark theme.
export const DARK_MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#1d1d24" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#1d1d24" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#9aa0a6" }] },
  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#3a3a44" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#2a2a33" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#1d1d24" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9aa0a6" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3a3a44" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0f1419" }] },
];
